import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { ShieldX, Loader2 } from "lucide-react";
import { validateInvitation } from "../../application/signUp";
import AuthLayout from "./AuthPageLayout";

export default function InvitePage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    if (!token) {
      setInvalid(true);
      return;
    }
    validateInvitation(token)
      .then((invitation) => {
        if (invitation.valid) {
          // One link format for both kinds of code; the code knows its door.
          const signup = invitation.kind === "center" ? "/signup/center" : "/signup";
          navigate(`${signup}?invite=${token}`, { replace: true });
        } else {
          setInvalid(true);
        }
      })
      .catch(() => setInvalid(true));
  }, [token, navigate]);

  if (invalid) {
    return (
      <AuthLayout>
        <div className="flex flex-col items-center gap-4 text-center py-8">
          <ShieldX className="w-12 h-12 text-red-500" />
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
            {t("invite.invalidTitle", "This invitation is no longer valid")}
          </h2>
          <p className="text-sm text-content-tertiary max-w-sm">
            {t(
              "invite.invalidDescription",
              "The invitation link you followed has expired or been disabled. Please contact the person who shared it with you."
            )}
          </p>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <div className="flex flex-col items-center gap-4 py-12">
        <Loader2 className="w-8 h-8 animate-spin text-brand-500" />
        <p className="text-sm text-content-tertiary">
          {t("invite.validating", "Validating invitation…")}
        </p>
      </div>
    </AuthLayout>
  );
}
